import { forwardRef } from 'react';
import MuiButton, { type ButtonProps as MuiButtonProps } from '@mui/material/Button';

export type ButtonProps = MuiButtonProps;

export const Button = forwardRef<HTMLButtonElement, ButtonProps>(
  ({ variant = 'contained', color = 'primary', disableElevation = true, ...rest }, ref) => (
    <MuiButton
      ref={ref}
      variant={variant}
      color={color}
      disableElevation={disableElevation}
      {...rest}
    />
  )
);

Button.displayName = 'Button';
